export const conference = {
    "入会注意事项(必读)":"入會註意事項(必讀)",
    "(1/3)请选择“加入会议”下载/调起腾讯会议app进入会议":"(1/3)請選擇“加入會議”下載/調起騰訊會議app進入會議；",
    "(2/3)请务必使用与课堂派注册/绑定的手机":"(2/3)請務必使用與課堂派註冊/綁定的手機；",
    "登陆腾讯会议":"登陸騰訊會議；",
    "(3/3)登陆后选择“课堂派”账号后直接进入会议":"(3/3)登陸後選擇“課堂派”賬號後直接進入會議；",
    "知道了":"知道了",
    "距开始":"距開始",
    "距离开始时间":"距離開始時間",
    "主持人":"主持人：",
    "来自":"来自：",
    "会议名称":"會議名稱",
    "开始时间":"開始時間",
    "结束时间":"結束時間",
    "会议简介":"會議簡介",
    "应用环节":"應用環節",
    "所属章节":"所屬章節",
    "同时发布给学生":"同時發布給學生",
    "会议添加成功":"會議添加成功！",
    "更新成功":"更新成功！",
    "预约的会议":"預約的會議",
    "正在跳转至腾讯会议请稍候":"正在跳轉至騰訊會議，請稍候……",
    "选择本次会议的录屏":"選擇本次會議的錄屏：",
    "录屏":"錄屏",
    "确定关联":"確定關聯",
    "关联成功":"關聯成功",
    "关联后的录屏可在会议详情中查看":"關聯後的錄屏可在會議詳情中查看",
    "暂无会议回放录屏":"暫無會議回放錄屏!",
    "去关联录屏":"去關聯錄屏",
    "倒计时":"倒計時:",
    "学生下载权限设置":"學生下載權限設置",
    "重新关联":"重新關聯",
    "权限设置":"權限設置",
    "修改会议":"修改會議",
    "取消会议":"取消會議",
    "复制邀请":"復制邀請",
    "您是否要删除该直播回放":"您是否要刪除該直播回放",
    "邀请信息复制成功":"邀請信息復制成功",
    "复制失败":"復制失敗",
    "确定要删除会议吗":"確定要刪除會議嗎",
    "再看看":"再看看",
    "确定要取消会议吗":"確定要取消會議嗎",
    "取消成功":"取消成功!",
    "发布会议":"發布會議",
    "关联录屏":"關聯錄屏",
    "已关联":"已關聯",
    "请输入会议名称":"請輸入會議名稱",
    "会议封面":"會議封面",
    "点击选择时间":"點擊選擇時間",
    "会议描述":"會議描述",
    "会议名称不允许为空":"會議名稱不允許為空",
    "会议结束时间不能小于开始时间":"會議結束時間不能小於開始時間",
    "名称":"名稱",
    "请输入名称内容":"請輸入名稱內容",
    "视频内容":"視頻內容",
    "描述":"描述",
    "编辑文章":"編輯文章",
    "视频封面":"視頻封面",
    "编辑视频内容":"編輯視頻內容",
    "视频内容不允许为空":"視頻內容不允許為空",
    "名称不允许为空":"名稱不允許為空",
    "视频":"視頻",
    "申请加入虚拟教研室可以和名师一起探讨教学哦":"申請加入虛擬教研室可以和名師壹起探討教學哦～",
    "暂无会议简介":"暫無會議簡介",
    "展开":"展開",
    "参与":"參與",
    "相关推荐":"相關推薦",
    "次浏览":"次瀏覽",
    "条评论":"條評論",
    "暂无相关推荐":"暫無相關推薦",
    "个人版":"個人版",
    "企业版":"企業版",
    "有回放":"有回放",
}
